import React from 'react'

interface IIconProps {
  width?: string
  color?: string
  className?: string
}

const Emergency: React.FC<IIconProps> = (props) => {
  return (
    <>
      <svg
        className={props.className}
        xmlns='http://www.w3.org/2000/svg'
        height={props.width ? props.width : '50px'}
        width={props.width ? props.width : '50px'}
        fill={props.color ? props.color : '#000000'}
        viewBox='0 0 48 48'
      >
        <path d='M22.5 26H25.5V14H22.5ZM24 31.5Q24.6 31.5 25.05 31.05Q25.5 30.6 25.5 30Q25.5 29.4 25.05 28.95Q24.6 28.5 24 28.5Q23.4 28.5 22.95 28.95Q22.5 29.4 22.5 30Q22.5 30.6 22.95 31.05Q23.4 31.5 24 31.5ZM26.1 43.6Q25.25 44.45 24 44.45Q22.75 44.45 21.9 43.6L4.4 26.1Q3.55 25.25 3.55 24Q3.55 22.75 4.4 21.9L21.9 4.4Q22.75 3.55 24 3.55Q25.25 3.55 26.1 4.4L43.6 21.9Q44.45 22.75 44.45 24Q44.45 25.25 43.6 26.1Z' />
      </svg>
    </>
  )
}

export default Emergency
